import { filesMap } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { registersMap } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { doDelete, doPatch, doPost } from './fetch.service';

type saveOrderResponse = string;
export function saveOrder(formModel: any, orderId: string = '') {
  const path = `/save/${orderId || ''}`;
  const body = JSON.stringify(formModel);
  const headers = new Headers({ 'Content-Type': 'application/json' });
  return doPatch<saveOrderResponse>(path, body, headers).then((response) => {
    //if (response && typeof response === 'string') {
    return response;
    //}
  });
}

export function sendOrder(formModel: any, registries: registersMap, orderId: string, currentFiles: filesMap) {
  if (!orderId) {
    throw new Error('orderId is not provided');
  }
  const path = `/send/${orderId}`;
  const payload = {
    currentFiles,
    formModel,
    registries,
  };
  const body = JSON.stringify(payload);
  return doPost(path, body, new Headers({ 'Content-Type': 'application/json' }));
}

export function deleteOrder(orderId: string) {
  const path = `/delete/${orderId}`;
  return doDelete(path);
}
